import { z } from 'zod'
import QuestionWrapper from '../../questionnaire/formSteps/QuestionWrapper'
import { QuestionFlowEnum } from '@strata-monorepo/shared-types'

type InterstitialOptionProps = {
  label: string
  value: QuestionFlowEnum
  subtext: string
}

export const interstitialOptions: InterstitialOptionProps[] = [
  {
    label: 'Quick match',
    value: QuestionFlowEnum.QUICK,
    subtext: 'Answer a few questions to find a great plan for my home',
  },
  {
    label: 'Deep dive',
    value: QuestionFlowEnum.DEEP_DIVE,
    subtext: 'Answer more questions to find the best plan for my home',
  },
]

export const interstitial = {
  component: QuestionWrapper,
  componentProps: {
    type: 'radio',
    title: `How would you like to shop for your plan?`,
    label: 'Quiz Start',
    options: interstitialOptions,
    formValue: 'interstitial',
    tooltip:
      'Take the deep dive quiz for a more personalized plan recommendation built around your energy use.',
    gridClassName: 'strata:@qm/qc:grid-cols-2',
    tracking: {
      stepName: 'Quiz Start',
      deepStepNumber: 0,
      quickStepNumber: 0,
      deepStepId: '0',
      quickStepId: '0',
      fieldName: 'start_reason',
    },
  },
  name: 'interstitialRadioGroup',
  schema: z.object({
    interstitial: z.string().min(1, 'Please select one of the options above.'),
  }),
  // IMPORTANT: do NOT add a `visibleIf` here. A previous version had a
  // self-hiding `visibleIf` (`interstitial !== quick && interstitial !== deepDive`)
  // which made the step disappear once answered. That broke `handlePrevStep`
  // back-navigation and silently prevented `onComplete` from firing.
  // Regression test: `formModel.test.ts` →
  // `fmpFormFlow — interstitialRadioGroup visibility (regression)`.
  coreIf: true, // Always core - entry point
}
